import { MENU_ITEMS } from '../data'
import { AlignJustify, X } from 'lucide-react';

const Navigation = ({ navOpen, onToggle, onClose, navRef }) => {
  return (
    <nav>
      {/* Desktop Menu */}
      <ul className="md:flex space-x-6 hidden">
        {MENU_ITEMS.map(({ title, href }) => (
          <li key={href}>
            <a href={href} className="navitem font-medium">
              {title}
            </a>
          </li>
        ))}
      </ul>

      {/* Mobile Menu Toggle */}
      <div
        ref={navRef}
        className={`space-y-2 md:hidden`}
        onClick={onToggle}
      >
        {/* Mobile Closed Menu */}
        {!navOpen && (
            <AlignJustify 
              size={40}
              strokeWidth={1.5}
              color='#0099D6'
              onClick={onClose}
              className='animate-pulse'
              />
        )}

        {/* Mobile Open Menu */}
        {navOpen && (
          <>
            <X 
              size={40}
              strokeWidth={1.5}
              color='#0099D6'
              className='animate-pulse'
              />

            <div className="w-full absolute md:hidden" style={{ top: '3.5rem', right: '0', zIndex: 99 }}>
              <ul className="menu2 font-medium flex flex-col md:p-0 mt-1 divide-y divide-slate-200 ">
                {/* Nav Items Lop */}
                {MENU_ITEMS.map(({ title, href, highlight }) => (
                  <li key={href}>
                    <a href={href} className="navitem font-medium">
                      <div
                        className="menu2element"
                        style={highlight ? { backgroundColor: '#e6f6ff' } : undefined}
                      >
                        {title}
                      </div>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </>
        )}
      </div>
    </nav>
  );
};

export { Navigation };